export default "__VITE_ASSET__zIEZLoC3__"